// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import initialAntennaLookupFormValues from 'components/SearchAndSelect/Sets/Antenna/initialFormValues'
import { initialize, setSubmitSucceeded } from 'redux-form'

// NOTE - in Path Database Lookup, we do not store the other antenna values.

const getInitialAntennaLookupValues = (sourceForm, lookupFormName) => (dispatch, getState) => {
  const initialValues = { ...initialAntennaLookupFormValues }

  let triggerSearchOnMount = false

  try {
    const { antennaCode } = getState().form[sourceForm].values

    if (antennaCode) {
      initialValues.antennaCode = antennaCode
      triggerSearchOnMount = true
    }
  } catch (e) {
    console.warn(`Warning: tried to initialize Antenna Lookup for sourceForm ${sourceForm} however the sourceForm was not properly initialized.`)
    console.warn(e)
  }

  // if we want the lookup to auto search on mount, we need set some things up in redux
  if (triggerSearchOnMount) {
    dispatch(initialize(lookupFormName, initialValues))
    dispatch(setSubmitSucceeded(lookupFormName))
  }

  return {
    initialValues,
    triggerSearchOnMount,
  }
}

export default getInitialAntennaLookupValues
